module.exports = __webpack_public_path__ + "static/media/email.c9af2e82.png";